import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import appOndemand from '../assets/products/app-ondemand.png';
import appReservations from '../assets/products/app-reservations.png';

const ResidencesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page residencesPage">
      <Header />
      <div className="page-header">Residential Building</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Residences</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Delight residents and their families with food and beverage at-a-click advanced ordering for pick-up at any venue in the community.\n\nFast, easy, mobile ordering and payment drives order volume and grows F&B revenue.\n\nAllow residents to choose their preferred table when making dining reservations.\n\nUse Graphical KPI dashboards and reports to analyze performance and identify opportunities to improve service and operations."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemand}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="Reserve"
          imgSrc={appReservations}
          onClick={() => navigate('/solutions/reserve')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default ResidencesPage;
